import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Reset scroll on every pathname change. Browsers don't do this for SPA nav,
// and it's the kind of thing that's silently broken until a stakeholder
// notices that clicking 'About' takes them to the bottom of the next page.
//
// Honours #hash anchors: if the new URL has a hash, leave scroll alone and
// let the browser (or anchor-handling code) do its thing.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
